import { cookieConstants } from "@/actions/constants/cookieConstants";
import { failure, request, success } from "@/utils/constants";

export const createCookiesReducer = (state = {}, action: any) => {
    switch (action.type) {
        case cookieConstants.createCookieRequest:
            return {
                ...request,
            };
        case cookieConstants.createCookieSuccess:
            return {
                ...success,
                cookies: action.payload,
            };
        case cookieConstants.createCookieFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
export const getCookiesReducer = (state = {}, action: any) => {
    switch (action.type) {
        case cookieConstants.getCookieRequest:
            return {
                ...request,
            };
        case cookieConstants.getCookieSuccess:
            return {
                ...success,
                cookies: action.payload,
            };
        case cookieConstants.getCookieFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
export const updateCookiesReducer = (state = {}, action: any) => {
    switch (action.type) {
        case cookieConstants.updateCookieRequest:
            return {
                ...request,
            };
        case cookieConstants.updateCookieSuccess:
            return {
                ...success,
                cookies: action.payload,
            };
        case cookieConstants.updateCookieFailure:
            return {
                ...failure,
            };
        default:
            return state;
    }
};
